import axios from "axios";
import { API_URL } from "../../../utils/constants";

export const getGCPSecretManagerApi = async (param) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const response = await axios({
      method: "GET",
      url: `${API_URL}gcp/secrets`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};
